import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeReservationTable, ReservationFormResponse } from 'src/app/features/reservations/models/Reservation';

export interface DialogData {
  reservationData: ChangeReservationTable | null,
  reservationResponse: ReservationFormResponse,
  errorType: number // 0 => Message, 1 => Warning,
  view: string
}

@Component({
  selector: 'app-takeaway-table-problem',
  templateUrl: './takeaway-table-problem.component.html'
})
export class TakeawayTableProblemComponent implements OnInit {
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<TakeawayTableProblemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
    if (!this.data.view) {
      this.data.view = 'floor';
    }
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  saveRecord() {

  }
}
